import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsMobileLayout } from '../../../../../../selectors/layout';

import { PromotionTypeChangeWarning } from './components';
import { selectPromotionTypeChangeReason } from '../../../../../../reducers/v2/promotion/selectors';

export const PromotionWarningContainer = () => {
  const promotionTypeChangeReason = useSelector(selectPromotionTypeChangeReason);
  const isMobileLayout = useSelector(selectIsMobileLayout);

  if (promotionTypeChangeReason) {
    return <PromotionTypeChangeWarning mobile={isMobileLayout} text={promotionTypeChangeReason} />;
  }

  return null;
};
